import {
  RESET_PURCHASE,
  RESET_SPECIFIC_PURCHASE,
  SET_PURCHASE,
  SET_UNPAID_POSTED_PURCHASES,
  SET_SPECIFIC_PURCHASE,
  SET_PURCHASE_REPORT,
} from "../Types/PurchaseTypes";

const initialState = {
  allPurchases: [],
  allPurchasesReport: [],
  unpaidPostedPurchases: [],
  specificPurchase: null,
};

const PurchaseReducer = (state = initialState, action) => {
  if (action.type === SET_PURCHASE) {
    return { ...state, allPurchases: action.payLoad };
  } else if (action.type === SET_PURCHASE_REPORT) {
    return { ...state, allPurchasesReport: action.payLoad };
  } else if (action.type === RESET_PURCHASE) {
    return { ...state, allPurchases: [] };
  } else if (action.type === SET_SPECIFIC_PURCHASE) {
    return { ...state, specificPurchase: action.payLoad };
  } else if (action.type === SET_UNPAID_POSTED_PURCHASES) {
    return { ...state, unpaidPostedPurchases: action.payload };
  } else if (action.type === RESET_SPECIFIC_PURCHASE) {
    return { ...state, specificPurchase: null };
  } else {
    return state;
  }
};

export default PurchaseReducer;
